<template>
    <div class="header1">
        <div class="header1_left">
            <img :src="logo" alt="">
            <div class="left_name">{{title}}</div>
        </div>
        <div class="header1_midd">
            <div class="midd_ipunt" @click.stop="ShowSea">
                <el-icon><Search /></el-icon>
                <div class="ipunt_text1">搜索资源</div>
            </div>
        </div>
        <div class="header1_right">
            <div class="right_but" @click.stop="ShowrightSel">
                <div class="right1" :class="isShowrightSel?'SkewY1':''"></div>
                <div class="right2" :class="isShowrightSel?'SkewY2':''"></div>
            </div>
            <div class="right_sel" v-if="isShowrightSel" @click.stop>
                <div class="sel_list1">
                    <div class="while listbox" :class="theme===1?'isSkin':''" @click="SeaSkin(1)">
                        <div class="while_box boxx"></div>
                        <div>浅色</div>
                    </div>
                    <div class="black listbox" :class="theme===2?'isSkin':''" @click.stop="SeaSkin(2)">
                        <div class="black_box boxx"></div>
                        <div>深色</div>
                    </div>
                </div>
                <div class="heng"></div>
                <div class="sel_list2">
                    <div class="list2_ul">
                        <div class="list2_item" v-for="i,index in aboutList" :key="index" @click.stop="SeaPop(index)">{{ i.name }}</div>
                    </div>
                    <component v-if="isShowPop" :is="aboutList[NumPop].component" @popclose="popclose"></component>
                </div>
            </div>
        </div>
    </div>

    <searchdetails v-if="isShowSearch" @handClose="closeSea"></searchdetails>
    <message1></message1>
</template>

<script setup>
import {computed, ref,onMounted} from 'vue'
import { useStore} from 'vuex'
import bus from '@/utils/bus';
import { GetTabgrade } from '@/api';

const store = useStore()


const isShowSearch = ref(false)  //是否展示搜索组件
const isShowlist3Seal = ref(false)  //是否展示语言选项
const isShowrightSel = ref(false)   //是否展示右上角
const isShowPop = ref(false)    // 是否展示弹窗
const NumPop = ref(null)    // 选中第几个弹窗
const aboutList = ref([])



const title = computed(()=>{return store.state.app.sysinfo.title})
const logo = computed(()=>{return store.state.app.sysinfo.logo})

onMounted(() => {
    GetTabgrade({type:1}).then(res=>{
        aboutList.value = res
        aboutList.value = aboutList.value.filter(i=>{return i.state!==0})
    }).catch()
    bus.on('ClosePop', () => {
        CloseAll()
        isShowrightSel.value = false
    });
});

const theme = computed(()=>{    //选中皮肤是什么颜色1:浅色，2:深色
    return store.state.app.theme
})


const SeaPop = (val)=>{
    CloseAll()
    if(aboutList.value[val].url){ window.open(aboutList.value[val].url);return }
    isShowPop.value = true
    NumPop.value = val
    // console.log(val,aboutList.value);
}

const CloseAll = ()=>{
    isShowPop.value = false
    isShowlist3Seal.value = false
}

const ShowSea = ()=>{
    isShowSearch.value = true
}
const ShowrightSel = ()=>{
    CloseAll()
    isShowrightSel.value = !isShowrightSel.value
}
const SeaSkin = (val)=>{
    store.commit('app/SET_THEME',val)
}

const closeSea = (val)=>{
    CloseAll()
    isShowSearch.value = val
    isShowlist3Seal.value = val
}

const popclose = ()=>{
    isShowPop.value = false
}

</script>

<style lang="scss" scoped>
.header1{
    background: var(--header-bac);
    width: 100vw;
    height: 5rem;
    display: flex;
    padding: 1vh 2vw;
    position: fixed;
    top: 0;
    z-index: 10;
    >div{
        flex:1;
    }
    .header1_left{
        display: flex;
        align-items: center;
        font-size: 1.3rem;
        font-weight: 700;
        cursor: pointer;
        color:var(--header-text1);
        img{
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
            margin: 0 1rem;
        }
        .left_name{
            font-size: 1rem;
            font-weight: 600;
        }
    }
    .header1_midd{
        display: flex;
        align-items: center;
        justify-content: center;
        .midd_ipunt{
            cursor: pointer;
            width: 20vw;
            height: 4vh;
            border-radius: 5rem;
            background: var(--input-bac);
            display: flex;
            align-items: center;
            .el-icon{
                margin-left: 1vw;
                color:var(--input-text);
                scale: 1.1;
            }
            .ipunt_text1{
                margin-left: .5vw;
                color:var(--input-text);
                font-weight: 500;
                scale: 1.1;
            }
        }
    }
    .header1_right{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        position: relative;
        .right_but{
            cursor: pointer;
            padding: 1rem;
            .right1{
            width: 1.2rem;
            height: 2px;
            background: var(--header-right);
            }
            .right2{
                width: .6rem;
                height: 2px;
                background: var(--header-right);
                margin-top: 5px;
                float: right;
                transition: all .1s ease-in-out;
            }
            &.right_but:hover{
                .right2{
                    width: 1.2rem;
                }
            }
            .SkewY1{
                transform: translateY(4px) rotate(-45deg);
            }
            .SkewY2{
                width: 100%;
                transform: translateY(-3px) rotate(45deg);
            }
        }
        .right_sel{
            // opacity: 0;
            position: absolute;
            top: 2rem;
            right: 0;
            margin: 1rem;
            width: 15rem;
            padding-top: .5rem;
            // height: 10vh;
            background: var(--header-rightsel);
            z-index: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: .5rem;
            box-shadow: 0 4px 24px rgb(32 43 54 / 6%);
            border: 1px solid rgb(53 71 103 / 6%);
            .sel_list1{
                flex:.3;
                display: flex;
                margin-bottom: 1rem;
                width: 90%;
                .listbox{
                    flex-direction: column;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    color:var(--header-rightsel-text1);
                    font-size: .8rem;
                    .boxx{
                        width: 4rem;
                        height: 2.5rem;
                        border-radius: 1rem;
                        margin: 10px;
                    }
                }
                .isSkin{
                    .boxx{
                        border:2px solid #6e8afb;
                    }
                }
                .while{
                    .while_box{
                        background: #ecebeb;
                    }
                }
                .black{
                    .black_box{
                        background: #000000;
                    }
                }
            }
            .heng{
                width: 90%;
                border-bottom:1px solid var(--header-rightsel-heng);
            }
            .sel_list2{
                flex:.5;
                width: 100%;
                padding: 0 1rem;
                color:var(--header-text1);
                .list2_ul{
                    width: inherit;
                    .list2_item{
                        width: inherit;
                        margin: 10px 20px;
                        height: 2.2rem;
                        line-height: 2.2rem;
                        font-size: .8rem;
                        border-radius: 1rem;
                        margin: 1rem 0;
                        padding: 0 1rem;
                        cursor: pointer;
                    }
                    .list2_item:hover{  
                        background: var(--header-rightsel-hover1);
                    }
                }
            }
            .sel_list3{
                flex:.2;
                width: 100%;
                padding: 0 1rem;
                position: relative;
                color:var(--header-text1);
                .list3_item{
                    display: flex;
                    margin: 1rem 0;
                    font-size: .8rem;
                    font-weight: 300;
                    cursor: pointer;
                    height: 2.2rem;
                    line-height: 2.2rem;
                    width: 100%;
                    border-radius: .5rem;
                    .item1_a{
                        flex: .9;
                        margin-left: 1rem;
                    }
                    .item1_b{
                        flex: .1;
                    }
                }
                .list3_item:hover{
                    background: var(--header-rightsel-hover1);
                }
                .list3_seal{
                    position: absolute;
                    top: 0;
                    right: calc(100% + 1rem);
                    width: 10rem;
                    height: 6rem;
                    border-radius: .5rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    background: var(--header-rightsel);
                    box-shadow: 0 4px 24px rgba(32, 43, 54, 0.06);
                    border: 1px solid rgba(53, 71, 103, 0.06);
                    >div{
                        flex: 1;
                        cursor: pointer;
                        border-radius: 0.5rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        >span{
                            width: 85%;
                            height: 70%;
                            display: flex;
                            align-items: center;
                            border-radius: .5rem;
                            padding-left: 1rem;
                            font-size: .8rem;
                        }
                    }
                    >div:hover{
                        >span{
                            background: var(--header-rightsel-hover1);
                        }
                    }
                }
            }
        }
    }
}
</style>